/**
 * assets/page-retour-en-garantie.js
 * Gedrag van sections/page-retour-en-garantie.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function () {
  var root = document.querySelector('[data-vc-retour]');
  if (!root) return;
  var choices = root.querySelectorAll('[data-vc-choice]');
  var intros = root.querySelectorAll('[data-vc-intro]');
  var formWrap = root.querySelector('[data-vc-form-wrapper]');
  var placeholder = root.querySelector('[data-vc-placeholder]');

  function activate(value) {
    choices.forEach(function (btn) {
      var isActive = btn.getAttribute('data-vc-choice') === value;
      btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      var color = value === 'herroeping' ? 'aqua' : 'koi';
      if (isActive) {
        btn.classList.add('shadow-lg');
        btn.classList.remove('border-slate-200');
        btn.classList.add('border-' + color);
        var dot = btn.querySelector('[data-vc-dot]');
        if (dot) dot.classList.replace('scale-0', 'scale-100');
      } else {
        btn.classList.remove('shadow-lg', 'border-aqua', 'border-koi');
        btn.classList.add('border-slate-200');
        var d2 = btn.querySelector('[data-vc-dot]');
        if (d2) d2.classList.replace('scale-100', 'scale-0');
      }
    });
    intros.forEach(function (el) {
      if (el.getAttribute('data-vc-intro') === value) {
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });
    if (placeholder) placeholder.classList.add('hidden');
    if (formWrap) {
      formWrap.classList.remove('hidden');
      /* Smooth scroll into view*/
      setTimeout(function () {
        formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }

  choices.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activate(btn.getAttribute('data-vc-choice'));
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activate(btn.getAttribute('data-vc-choice'));
      }
    });
  });

  /* Auto-open via URL hash: #herroeping of #retour*/
  var hash = (window.location.hash || '').replace('#', '').toLowerCase();
  if (hash === 'herroeping' || hash === 'retour') {
    activate(hash);
  }
})();
